var render = function render(){var _vm=this,_c=_vm._self._c;return _c('emd-button',_vm._b({attrs:{"type":"text","color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},'emd-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }